import React from 'react'
import dynamic from 'next/dynamic'
import { BsTelephone } from 'react-icons/bs'

const Hero = dynamic(() => import('../components/Hero'))
const Footer = dynamic(() => import('../components/Footer'))

const Terminal = () => {
  return (
    <>
      <Hero>
        <section className='lg:px-20 xl:px-40 md:px-20 px-6 py-4 '>
          <section className='rounded-xl bg-white md:mt-40 md:pb-20 overflow-x-hidden mt-16'>
            <section className='bg-bgGrey h-20 flex items-center md:px-12 py-4 px-6'>
              <form className='bg-textInputBg h-full md:w-3/5  rounded-lg overflow-hidden flex items-center text-sm px-6 w-4/5'>
                <input
                  className='bg-transparent h-full w-full text-white bg-textInputBg'
                  type='search'
                  name='search'
                  id='search'
                  placeholder='Search for terminal'
                />
              </form>
            </section>
            <section className='flex flex-col py-4 md:px-12 px-6'>
              <section className=' py-2'>
                <details className='cursor-pointer'>
                  <summary className='focus:outline-none mb-4 text-base lg:text-xl border-b border-solid border-booking pb-2'>
                    Lagos
                  </summary>
                  <section className='flex flex-col md:flex-row justify-between items-center mb-6'>
                    <section className='w-full card md:py-6 md:px-6 px-4 py-6 mb-6 md:mb-0 md:w-48'>
                      <h3 className='text-gray800 capitalize md:text-xl'>
                        lagos
                      </h3>
                      <p className='py-6 text-gray600 text-sm md:text-lg'>
                        Plot 4, 1st Avenue, Festac Town, Lagos
                      </p>
                      <section className='flex w-full'>
                        <section className='items-center flex justify-center bg-mainColor md:h-12 md:w-12 h-10 w-10 rounded-lg text-white text-sm md:text-lg'>
                          <BsTelephone />
                        </section>
                        <section className='md:px-0 lg:px-3 flex w-11/12'>
                          <section className='flex flex-col text-gray600 md:text-base capitalize px-2 md:pr-6 border-r border-solid border-booking text-xs'>
                            <p>Call Lisa</p>
                            <a href='tel:+2348125283861'>+2348125283861</a>
                          </section>
                        </section>
                      </section>
                    </section>
                  </section>
                </details>
                <details className='cursor-pointer'>
                  <summary className='focus:outline-none mb-4 text-base lg:text-xl border-b border-solid border-booking pb-2'>
                    Enugu
                  </summary>
                  <section className='flex flex-col md:flex-row justify-between items-center mb-6'>
                    <section className='w-full card md:py-6 md:px-6 px-4 py-6 mb-6 md:mb-0 md:w-48'>
                      <h3 className='text-gray800 capitalize md:text-xl'>
                        Enugu
                      </h3>
                      <p className='py-6 text-gray600 text-sm md:text-lg'>
                        20 Market Road, beside Fine Brothers, along Holy Ghost
                        Cathedral, Enugu
                      </p>
                      <section className='flex w-full'>
                        <section className='items-center flex justify-center bg-mainColor md:h-12 md:w-12 h-10 w-10 rounded-lg text-white text-sm md:text-lg'>
                          <BsTelephone />
                        </section>
                        <section className='md:px-0 lg:px-3 flex w-11/12'>
                          <section className='flex flex-col text-gray600 md:text-base capitalize px-2 md:pr-6 border-r border-solid border-booking text-xs'>
                            <p>Call Favour</p>
                            <a href='tel:+2349065383758'>+234 906 538 3758</a>
                          </section>
                        </section>
                      </section>
                    </section>
                  </section>
                </details>
              </section>
            </section>
          </section>
        </section>
      </Hero>
      <Footer />
    </>
  )
}

export default Terminal
